import { render } from "./StyleGuide.vue?vue&type=template&id=28ef4880&scoped=true&ts=true"
import script from "./StyleGuide.vue?vue&type=script&lang=ts"
export * from "./StyleGuide.vue?vue&type=script&lang=ts"

import "./StyleGuide.vue?vue&type=style&index=0&id=28ef4880&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ef4880"]])

export default __exports__